import { useCallback } from "react";
import { buildGuardianshipPayload } from "../bondRetrievalPayloadBuilders";
import { calculatePremium } from "../../../../features/premium/domain/calculatePremium";
import useBondRetrieveBase from "./useBondRetrieveBase";

function useGuardianshipBondRetrieve() {
  const buildPayload = useCallback(
    (globalState, status, billingMethod, isIndemnityReceived) =>
      buildGuardianshipPayload(globalState, billingMethod, isIndemnityReceived, status),
    []
  );

  const calculateCorrectionPremium = useCallback((amount, { globalState, data }) => {
    const wardDob =
      globalState.basicInformation?.dateOfDeath || data?.guardianshipbond?.ward_date_of_birth;
    const bondSubCategory =
      globalState.basicInformation?.bondSubCategory || data?.bond_sub_category;
    return calculatePremium(amount, wardDob, bondSubCategory);
  }, []);

  return useBondRetrieveBase("guardianship", {
    buildPayload,
    calculateCorrectionPremium,
  });
}

export default useGuardianshipBondRetrieve;
